import { useState, useEffect } from 'react';

export default function BackToTop({ threshold = 280 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed z-40 left-4 bottom-24 sm:bottom-28 w-12 h-12 rounded-full bg-[#232F3E] text-orange-400 border border-orange-500/40 shadow-xl hover:bg-[#37475A] flex items-center justify-center touch-manipulation"
      aria-label="Back to top"
      title="Back to top"
    >
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}
